<template>
  <nx-show-more
    :color="dark ? 'nx-neutral-200' : 'nx-neutral-600'"
    button-classname="pa-0 ma-0"
    :hidden="hidden"
  >
    <v-list dense>
      <v-list-tile
        v-if="read && !pinned"
        ripple
        @click="$emit('unread')"
      >
        <v-list-tile-avatar>
          <v-icon>mark_email_unread</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-title>{{ $t('message.common.unread') }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile
        v-if="!pinned"
        @click="$emit('pin')"
      >
        <v-list-tile-avatar>
          <v-icon>push_pin</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-title>{{ $t('message.common.pin') }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile @click="$emit('delete')">
        <v-list-tile-avatar>
          <v-icon>delete</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-title>{{ $t('message.common.delete') }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </nx-show-more>
</template>
<script>
import NxShowMore from '@/components/menu/ShowMore.vue';

export default {
  name: 'NxNotificationActions',
  components: { NxShowMore },
  props: {
    dark: Boolean,
    hidden: Boolean,
    read: Boolean,
    pinned: Boolean,
  },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variables.styl'

</style>
